import React, { Component } from 'react'
import '../css/fuwufei.css'
import { ztcgfuwufei} from '../../action/investmentAction';
import { connect } from 'react-redux';
import { hashHistory } from "react-router";
import Util from '../../util.js';

class Fuwuqimingxi extends Component {
  constructor(props) {  
    super(props); 
    this.state = {
      loadingFlag: false,
        xinxi:[],
    } 
  }

  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    let { dispatch } = this.props;
    let _this = this;
    let data1 = {
      superFundCode:this.props.location.state.superFundCode,
        }
      dispatch(ztcgfuwufei(data1,this.callbackData.bind(this),_this))
  }
  callbackData(data){
    console.log(data)
      this.setState({
        xinxi:data
      })
  }
  getNum=(num1,num2)=>{
    if(num1 === null && num2 === null){
      return null
    }else if(num1 === null){
      return num2 + '份'
    }else if(num2 === null){
      return num1 + '元'
    }else if(num1 == num2){
      return num1 + '元'
    }else{
      return null
    }
  }
    fuwumingxi(res){
        hashHistory.push({
            pathname:'/Feiyongxiangqing',
            state:{
              suoyoufuwufei:res,
             superFundCode:this.props.location.state.superFundCode
            }
          })
    }
  render() {
    let {xinxi}=this.state
    return (
      <div id='body1'>
          <div className="NHeader_container">
        <div className="NHeader_wrap">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">投顾服务费</div>
            <div className="NHeader_share">
            </div>
          </div>
        </div>
      </div>
          <div className='fuwuconter'>
              <div className='fuwuconterTop'>
                  <div className='fuwuconterTopTitle'>
                  当前服务标准
                  </div>
                  <div className='fuwuconterbottom'>
                  投顾服务费等于每日服务费的加总，每日服务费=当日您持有的总资产*投顾服务费率/当年天数（如遇服务费率打折或者减免等活动，则按活动后费率计算）
                  </div>
              </div>
              <div className='fuwufeiCard'>
                  <div className='fuwufeiCardTop1'>
                      <div className='fuwufeiCardTop1Left'>费用详情</div>
                      <div className='fuwufeiCardTop1Right' onClick={()=>this.fuwumingxi(xinxi.allManageFee)}>
                      <img className="fuwufeiCardTop1Righttu" src={require('../../imgs/iconhxcf_icon_youjiantou_10_gray.png')} />
                      </div>
                  </div>
                  <div className='fuwufeiCardTop2'>
                      <div className='fuwufeiCardTop2Left'>所有服务费</div>
                      <div className='fuwufeiCardTop2Right'>{ xinxi.allManageFee  == null  ? "" :Util.thousandCount(xinxi.allManageFee) +"元"}</div>
                  </div>
                  <div className='fuwufeiCardTop3'>
                      <div className='fuwufeiCardTop3Left'>待收服务费</div>
                      <div className='fuwufeiCardTop3Right'>{ xinxi.pendingFee == null  ? "" :Util.thousandCount(xinxi.pendingFee) +"元"}</div>
                  </div>
                  <div className='fuwufeiCardTop4'>
                      <div className='fuwufeiCardTop4Left'>已付服务费</div>
                      <div className='fuwufeiCardTop4Right'>{ xinxi.deductFee == null  ? "" :Util.thousandCount(xinxi.deductFee) +"元"}</div>
                  </div>
              </div>
          </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
  return {
  }
}
export default connect(mapStateToProps)(Fuwuqimingxi);



// WEBPACK FOOTER //
// ./src/components/fundDetail/Fuwuqimingxi.js